import { render, staticRenderFns } from "./VComponentOLD.vue?vue&type=template&id=5d44b808"
import script from "./VComponentOLD.vue?vue&type=script&lang=js"
export * from "./VComponentOLD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports